import React          from 'react';
import ContactHeader  from 'Widgets/ContactHeader';
import ContactDetails from 'Widgets/ContactDetails';

export default function ContactBlock() {
    return (
        <div role="home-contact" id="contact">
            <ContactHeader
                className="minor-margin--bottom"
                isHomePage
            />
            <ContactDetails />
        </div>
    );
};
